// helpers.ts -- Pure utility functions for G204 (Sales Allowance) form

/** Convert ISO date string to HTML date input value (YYYY-MM-DD) */
export const dateToInput = (v: string | null | undefined): string => {
  if (!v) return '';
  return v.substring(0, 10);
};

/** Convert HTML date input value to ISO date string */
export const inputToDate = (v: string): string | null => {
  if (!v) return null;
  return v + 'T00:00:00Z';
};

/** Format number with locale grouping, max 2 decimals */
export const fmt = (v: number | null | undefined): string => {
  if (v == null || v === 0) return '0';
  return v.toLocaleString('en-US', { maximumFractionDigits: 2 });
};

/** Determine if a field should be disabled */
const ALWAYS_READONLY = new Set([
  'fg140_01', 'fg140_14', 'fg140_15', 'fg140_18',
  'fg140_91', 'fg140_92', 'fg140_93',
]);

export const isFieldDisabledFn = (key: string, isEditing: boolean): boolean => {
  if (!isEditing) return true;
  if (ALWAYS_READONLY.has(key)) return true;
  return false;
};

/** Get status badge for approval status (BR-08) */
export const getStatusBadge = (record: { fg140_80?: string } | null): { text: string; cls: string } | null => {
  if (!record) return null;
  const s80 = (record.fg140_80 || '').trim();
  if (s80 === 'P') return { text: '已核准', cls: 'badge-success' };
  return null;
};

/** Check if record is locked (approved, cannot edit/delete) */
export const isApproved = (record: { fg140_80?: string } | null): boolean => {
  if (!record) return false;
  return (record.fg140_80 || '').trim() === 'P';
};
